import { render, staticRenderFns } from "./account-register.vue?vue&type=template&id=a1ce78fc"
import script from "./account-register.vue?vue&type=script&lang=js"
export * from "./account-register.vue?vue&type=script&lang=js"
import style0 from "./account-register.vue?vue&type=style&index=0&id=a1ce78fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports